module.exports = {
  "dof-radiogroup-box": {
    "position": "fixed",
    "left": "0",
    "right": "0",
    "flexDirection": "column",
    "overflow": "hidden",
    "zIndex": 1000
  },
  "dof-radiogroup-bottom": {
    "flexDirection": "row",
    "alignItems": "center",
    "backgroundColor": "#ffffff",
    "overflow": "hidden"
  },
  "btn-grp-text": {
    "flex": 1,
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "32",
    "lineHeight": "96",
    "textAlign": "center",
    "backgroundColor:active": "#9fa0a0"
  },
  "btn-cancel": {
    "borderRightWidth": "1",
    "borderRightStyle": "solid",
    "borderRightColor": "#d7dde4",
    "color": "#616C73"
  },
  "btn-confirm": {
    "color": "#1E2E37"
  },
  "dof-radiogroup-title": {
    "width": "550",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "32",
    "lineHeight": "36",
    "color": "#020f13",
    "textAlign": "center"
  },
  "dof-radiogroup-content": {
    "backgroundColor": "#f2f2f2",
    "paddingBottom": "16"
  },
  "dof-radiogroup-item-wrapper": {
    "paddingTop": "30",
    "paddingBottom": "30",
    "backgroundColor": "#ffffff"
  },
  "dof-radiogroup-item": {
    "flexDirection": "row",
    "alignItems": "center",
    "minHeight": "90",
    "paddingRight": "20",
    "paddingTop": "30",
    "paddingBottom": "30",
    "backgroundColor:active": "#f5f5f5"
  },
  "icon-wrapper": {
    "height": "25",
    "width": "100",
    "textAlign": "left",
    "paddingLeft": "20"
  },
  "item-icon": {
    "height": "25",
    "width": "25"
  },
  "item-text": {
    "width": "550",
    "fontSize": "32",
    "lineHeight": "36",
    "textAlign": "center"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-043f9315!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-select/index.vue
// module id = 421
// module chunks = 0 1